






























































import Vue from "vue";
import { UseModal } from "@/components/root/modal";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { state } from "../data/state";
import ManageTrustModalVue from "@/views/customize/in-motion/exposure-control/manage-trust-modal/ManageTrustModal.vue";
import { SharedState } from "@/common/state";

export default Vue.extend({
  components: { SensitivityLabel },
  setup() {
    const { current_subject, entity_info_trust } = state;

    const manage_trust = async (label_id: string) => {
      if (SharedState.restrictions.is_restricted_app("trust_management")) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Trust Management"
        );
        return;
      }
      const label = SharedState.getInfoType(label_id)!;
      if (SharedState.restrictions.is_restricted_info(label.code)) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          `Trust Management for ${label.labelName} information`
        );
        return;
      }
      const { id, name, email, type } = current_subject.value;
      const res = await UseModal().show(ManageTrustModalVue, {
        entity: {
          id,
          name,
          email,
          type,
        },
        info_types: [label_id],
      });
      if (res.type === "success") {
        // @ts-ignore
        const val: { [key: string]: number } = res.msg;
        entity_info_trust.value = entity_info_trust.value.map((d) => {
          if (d.id === label_id) {
            return {
              ...d,
              level: +val[label_id],
            };
          }
          return d;
        });
      }
    };

    return {
      entity_info_trust,
      current_subject,
      manage_trust,
    };
  },
});
